

























































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { CreateTypeCreneauModel } from "@/api/models/typesCreneau/typeCreneau";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "create-type-creneau",
})
export default class CreateTypeCreneau extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewTypeCreneauSidebarActive!: boolean;
  loading = false;

  required = required;

  newTypeCreneau: CreateTypeCreneauModel = {};

  resetForm() {
    this.newTypeCreneau = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.typesCreneau
      .post(this.newTypeCreneau)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'une type de créneau",
            text: "Type de créneau créé avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-types-creneau");
        this.$emit("update:is-add-new-type-creneau-sidebar-active", false);
        this.loading = false;
      });
  }
}
